import { global } from ":shared/app";

export const endpoint = "teaming/request/";

// TODO : add data type
export async function post(data) {
  return global.api
    .postAuth(endpoint, data, {
      // TODO : add proper type
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(async (res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
